import { createContext, useCallback, useContext, useEffect, useState } from "react";
import { api } from "@/lib/api";

const DEFAULTS = { display_name: "Sitera", tagline: "Building Excellence", has_logo: false };
const BrandingContext = createContext({ ...DEFAULTS, refresh: () => {} });

export function BrandingProvider({ children }) {
  const [branding, setBranding] = useState(DEFAULTS);

  const refresh = useCallback(() => {
    return api.get("/public/branding").then(({ data }) => setBranding(data)).catch(() => {});
  }, []);

  useEffect(() => { refresh(); }, [refresh]);

  return <BrandingContext.Provider value={{ ...branding, refresh }}>{children}</BrandingContext.Provider>;
}

export const useBranding = () => useContext(BrandingContext);
